import { render, staticRenderFns } from "./MultipleSelection.vue?vue&type=template&id=0fb653fd&scoped=true"
import script from "./MultipleSelection.vue?vue&type=script&lang=js"
export * from "./MultipleSelection.vue?vue&type=script&lang=js"
import style0 from "./MultipleSelection.vue?vue&type=style&index=0&id=0fb653fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb653fd",
  null
  
)

export default component.exports